import script from "./MobileDefaultLayout.vue?vue&type=script&lang=js"
export * from "./MobileDefaultLayout.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__